import { PBPGetResponse } from '@percent/admin-dashboard/services/pbpResponses'
import { CountryList, countriesServiceCapabilities } from './countriesService.types'

export const countriesService = ({ percentClient }: countriesServiceCapabilities) => ({
  // Authenticates by the admin session cookie; no partner public key.
  getCountries: () =>
    percentClient.get<PBPGetResponse<CountryList>>('v1/countries', {
      params: {
        hasRegistry: true
      },
      withCredentials: true
    })
})
